module.exports = __webpack_public_path__ + "static/media/aboutus.04c6600a.svg";